function TimeslotsSkeleton() {
  return (
    <div className="flex-1">
      {/* Header skeleton */}
      <div className="mb-4">
        <SkeletonBox className="w-64 h-7 mb-2" />
        <SkeletonBox className="w-40 h-4" />
      </div>

      {/* Timezone selector skeleton */}
      <div className="mt-2 mr-8">
        <SkeletonBox className="w-full h-12" />
      </div>

      {/* Timeslots container skeleton with proper height */}
      <div className="relative mt-3.5">
        <div className="relative overflow-hidden">
          <div className="space-y-2 mr-4">
            {Array.from({ length: 5 }).map((_, i) => (
              <SkeletonBox key={i} className="w-full h-14" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
// Skeleton component for loading states
function SkeletonBox({ className }: { className?: string }) {
  return <div className={`animate-pulse bg-gray-200 rounded ${className}`} />;
}

export function SideBySideLoadingState() {
  return (
    <div className="flex">
      {/* Calendar skeleton - matches actual calendar width */}
      <div className="flex-1 mr-8">
        <div className="h-full animate-pulse bg-gray-200 rounded-lg" />
      </div>

      {/* Timeslots skeleton - matches actual timeslots layout */}
      <div className="flex-1 ml-4">
        <TimeslotsSkeleton />
      </div>
    </div>
  );
}
